import { clientService, clientService1 } from "./client";

const baseUrl = "http://localhost:8080"
// const baseUrl2 ="https://k8s-prod-avahivei-9d7272afda-676220939.ap-south-1.elb.amazonaws.com/"
const baseUrl2 = "https://hivev2.avasoft.com"
export const GetSessions = async () => {
    const response = await clientService ("GET", baseUrl2 + "/app/v2/certificates/getcourses");
    return response;
}

// SQ- 1.32 - 1.46 : Handles the fetchCourseDetails to fetch courses
export const fetchCourseDetails = async (payload) => {
    const response = await clientService("POST",baseUrl2 + "/app/v2/certificates/getcourses",payload);
    return response.data;
};

//  SQ- 5.11 - 5.22 Function to post a new course
export const postCourse = async (courseData) => {
    const response = await clientService("POST", baseUrl2 + "/app/v2/certificates/course", courseData);
    return response;
};

//SQ 8.49 - 8.60 : Handles importcoursedetails
export const importcoursedetails = async (courseData) => {
    const response = await clientService("POST", baseUrl2 + "/app/v2/certificates", courseData);
    return response;
};
//SQ- 2.25 - 2.30 : Handles the postapprovaldetails for updating the approval status
export const postapprovaldetails = async (approvalData) => {
    const response = await clientService("POST", baseUrl2 + "/app/v2/certificates/approval", approvalData);
    return response.data;
};

//SQ 3.22 - 3.31 : Handles the applyForCertification 
export const applyForCertification = async (payload) => {
    const response = await clientService("POST", baseUrl2 + "/app/v2/certificate", payload);
    return response.data;
};

//SQ- 1.27 - 1.40 : fetchCertificationDetails
export const fetchCertificationDetails = async (params) => {
    const response = await clientService("GET", baseUrl2 + "/app/v2/certificate", {params});
    return response.data;
};

export const uploadfiletos3 = async (payload) => {
    const response = await clientService1("POST", baseUrl2 + "/app/v2/certificate/upload", payload);
    return response.data;
};

export const postcertificationDetails = async (payload) => {
    const response = await clientService("POST", baseUrl2 + "/app/v2/certificate",payload);
    return response.data;
};


export const getDomain = async () => {
    const response = await clientService("GET", baseUrl2 + "/app/v2/domain");
    return response.data;
};

export const getCertificationCount = async (params) => {
    const response = await clientService("GET", baseUrl2 + "/app/v2/certificate/count",{params});
    return response.data;
};